module.exports = __webpack_public_path__ + "img/fa.923d62e1.png";